<template>
    <div class="position-fixed vue-modal-back p-3"
         v-bind:class="{'active': visible}"
         style="top: 0px; left: 0px; height: 100vh; width: 100vw"
         @click.self="close">

        <div v-bind:class="{'active': visible}" class="vue-modal position-relative shadow">
            <div class="vue-modal-content overflow-auto">
                <ShadowHtml v-if="html" :html="html"/>
            </div>
        </div>

    </div>
</template>

<script>
    import ShadowHtml from "@/components/ShadowHtml.vue";
    import {getCookie, setCookie} from "@/functions";

    // Páginas de bienvenida (CMS) por idioma
    const WELCOME_POSTS = {
        es: 12924,
        en: 12932,
        fr: 12935,
    };

    const RENDER_URL = 'https://api.sethotels.net/api/cms-v2/post/';
    const COOKIE_NAME = 'welcome_seen';
    const COOKIE_DAYS = 30;

    export default {
        name: 'WelcomeModal',

        components: {ShadowHtml},

        data() {
            return {
                visible: false,
                html: null,
            };
        },

        methods: {
            close() {
                this.visible = false;
            },

            async loadWelcome() {
                // Ya se mostró en los últimos COOKIE_DAYS días
                if (getCookie(COOKIE_NAME)) {
                    return;
                }

                const locale = localStorage.locale || 'es';
                const postId = WELCOME_POSTS[locale] || WELCOME_POSTS.es;

                try {
                    const resp = await fetch(RENDER_URL + postId + '/render');
                    if (!resp.ok) {
                        return;
                    }
                    this.html = await resp.text();
                    this.visible = true;
                    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
                } catch (e) {
                    // Si falla la carga, no mostramos nada
                }
            }
        },

        mounted() {
            this.loadWelcome();
        }
    };
</script>

<style scoped>

    .vue-modal-back {
        background-color: rgba(0, 0, 0, 0.0);
        visibility: hidden;
        transition: ease 300ms;
        z-index: 1000;
    }

    .vue-modal-back.active {
        background-color: rgba(0, 0, 0, 0.5);
        visibility: visible;
    }

    .vue-modal {
        z-index: 1001;
        top: -100vh;
        width: 550px;
        max-width: 100%;
        border: none !important;
        visibility: hidden;
        margin: auto;
        background-color: white;
        border-radius: 14px;
        overflow: hidden;
        transition: ease 400ms;
    }

    .vue-modal.active {
        top: 40px;
        visibility: visible;
    }

    .vue-modal-content {
        max-height: calc(100vh - 80px);
    }

</style>
